module.exports = __webpack_public_path__ + "static/media/star-empty-dark.1ca4d119.svg";